import featureFlags from './featureFlags.json';

export type FeatureToggle = Record<string | number, FeatureToggleValue>;
export type FeatureToggleValue = {
  isEnabled?: boolean;
  chains?: string[];
  domains?: string[];
  networks?: string[];
};

const getFeatureFlagsConfig = (config: Record<string, FeatureToggle> = featureFlags): FeatureToggle => {
  const stage = (process.env.REACT_APP_STAGE || 'unknown').toLowerCase();
  if (!(stage in config)) {
    // default to all toggles disabled
    return {};
  }

  return config[stage];
};

export default getFeatureFlagsConfig;
